// extracted by mini-css-extract-plugin
export default {"root":"CompoundTable_root__+5X0D"};